<mat-form-field
        appearance="outline"
        [formGroup]="formGroup"
        style="margin-bottom: -1.25em; width: 100%;">
    <mat-label>{{config.label}}</mat-label>
    <input matInput [required]="requerido"
           type="text"
           [placeholder]="config.placeholder || ''"
           [value]="valorFormatado"
           (input)="onInput($event)"
           [readonly]="config.readonly"
           maxlength="18" />
</mat-form-field>